module.exports = __webpack_public_path__ + "static/img/thinkoffice.4dfe30a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thinkoffice.png
// module id = YEz9
// module chunks = 1